import { render, staticRenderFns } from "./gift-cards.terms.vue?vue&type=template&id=360148fe"
import script from "./gift-cards.terms.vue?vue&type=script&lang=js"
export * from "./gift-cards.terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports